export const LETTER_JACKET_PRODUCT_OSR = 'JW011W1'
export const SOFTSHELL_JACKET_PRODUCT_OSR = 'JOW705WEB'
export const SOFTSHELL_JACKET_TITLE = 'Letter Jackets & Outerwear'
export const SOFTSHELL_JACKET_BANNER_TITLE = 'Shop Letter Jackets & Outerwear'
export const NO_JACKET_HERO_BANNER_MSG = 'Looking for Custom Letter Jackets for your school? <a href="/graduation/high-school/forms/Registration-Forms/letter-jacket">Request one here</a>.'